import makeCrudModule from '@/factories/CrudModelFactory';
import offersService from '@/services/offers';

export default makeCrudModule({
    service: offersService,
    dateConvert: [],
    useCache: true
});
